import React from "react";
import { Box, Typography, Grid, Avatar } from "@mui/material";
import { useTheme } from "@mui/material/styles";

/**
 * A component that displays assistant examples directly below a specific box
 * @param {Object} props
 * @param {string} props.title - Title for the examples section
 * @param {Array} props.examples - Array of example assistants
 * @param {Function} props.navigate - Navigation function
 */
const AssistantExamplesSection = ({ title, examples, navigate }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mt: 6, width: "100%" }}>
      <Typography
        variant="h6"
        sx={{ fontWeight: 500, mb: 2, fontSize: "1.1rem", textAlign: "center" }}
      >
        {title}
      </Typography>
      <Grid container spacing={2}>
        {examples.map((example, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor:
                  theme.palette.mode === "dark" ? "#2a3742" : "white",
                borderRadius: "8px",
                padding: "12px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor:
                    theme.palette.mode === "dark" ? "#374856" : "#eeeeee",
                  transform: "translateY(-2px)",
                },
              }}
              onClick={() => navigate(example.url)}
            >
              <Avatar
                src={example.image}
                alt={example.name}
                sx={{
                  width: 50,
                  height: 50,
                  mr: 2,
                  borderRadius: 2,
                }}
              />
              <Box>
                <Typography fontWeight={500}>{example.name}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {example.description}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AssistantExamplesSection;
